import { colors, cbSemanticCssVars, typographyCss } from '@creditornot/cb-ingredients';
import React from 'react';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';

type Props = {
  num: number;
  label: string;
  to: string;
};

const ACTIVE_CLASS_NAME = 'active';

const Root = styled(NavLink).attrs({ activeClassName: ACTIVE_CLASS_NAME })`
  min-width: 84px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-decoration: none;
`;

const Num = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  border: 2px solid ${cbSemanticCssVars.borderPrimary};
  border-radius: 50%;
  width: 40px;
  height: 40px;
  font-weight: 600;
  font-size: 23px;
  color: ${cbSemanticCssVars.textSecondary};
  margin-block-end: 8px;
  ${Root}.${ACTIVE_CLASS_NAME} & {
    border-color: ${colors.wolt100};
    background-color: ${colors.wolt100};
    /* ignore-color */
    color: ${colors.salt100};
  }
`;

const Label = styled.div`
  ${typographyCss.Body3}
  color: ${cbSemanticCssVars.textSecondary};
  ${Root}.${ACTIVE_CLASS_NAME} & {
    font-weight: 700;
  }
`;

const NavigationStep = ({ num, label, to }: Props) => {
  return (
    <Root to={to}>
      <Num>{num}</Num>
      <Label>{label}</Label>
    </Root>
  );
};

export default NavigationStep;
